<template>
    <li class="card card--course card--backed card--colour-white card--standard card--fixed card--ambition">
        <a :href="event_url" class="card__content" >
            <div class="card__body">
                <div class="card__image">
                    <img class="" :alt="event.title" :title="event.title" :src="event.banner_image !== null ? event.banner_image.sizes.thumbnail.url : fallback_thumbnail">
                    <div class="card__date">
                        <span>{{ event_date() }}</span>
                    </div>
                </div>
                <div class="card__text">
                    <div class="card__title h3">{{ event.title }}</div>
                </div>
                <ul class="simple-list">
                    <li v-if="this.online_event">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><title>cloud</title><path d="M16.006 16h-10.006c-3.308 0-6-2.692-6-6s2.692-6 6-6c1.602 0 3.137 0.643 4.26 1.775 0.088-0.194 0.196-0.38 0.325-0.555 0.564-0.764 1.467-1.22 2.415-1.22 1.654 0 3 1.346 3 3 0 0.351-0.061 0.694-0.178 1.017 0.061-0.003 0.122-0.004 0.184-0.004 2.202 0 3.994 1.792 3.994 3.994s-1.792 3.994-3.994 3.994zM6 5c-2.757 0-5 2.243-5 5s2.243 5 5 5h10.006c1.651 0 2.994-1.343 2.994-2.994s-1.343-2.994-2.994-2.994c-0.354 0-0.699 0.061-1.026 0.18-0.218 0.080-0.462-0.001-0.59-0.195s-0.104-0.45 0.056-0.619c0.357-0.376 0.554-0.865 0.554-1.379 0-1.103-0.897-2-2-2-0.642 0-1.229 0.297-1.61 0.814-0.23 0.312-0.365 0.678-0.388 1.057-0.013 0.212-0.159 0.393-0.363 0.45s-0.423-0.020-0.545-0.193c-0.11-0.156-0.229-0.307-0.354-0.447-0.949-1.068-2.312-1.681-3.74-1.681z"></path></svg>
                        <span>Online event</span>
                    </li>
                    <li v-if="this.campus">
                        <svg width="15px" height="20px" viewBox="0 0 15 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>location-sign</title> <g><path d="M7.32780372,0 C3.28720714,0 0,3.28743253 0,7.32782258 C0,11.2170448 5.76614376,19.119635 6.04923846,19.5044112 C6.40574172,19.8035283 6.34930191,19.7695709 6.61740807,19.8769866 C6.87647022,19.9879353 7.27604088,20 7.32780372,20 C7.38036702,20 7.74209798,20 8.01919194,19.8769866 C8.21365206,19.7952399 8.40364462,19.671048 8.5891696,19.5044112 C8.66251134,19.435168 14.6562478,11.2170448 14.6562478,7.32782258 C14.6562478,3.28743253 11.368507,0 7.32780372,0 Z M7.30742299,4.67840679 C8.75738761,4.67840679 9.93643919,5.85751182 9.93643919,7.30742299 C9.93643919,8.75658593 8.75733417,9.93643919 7.30742299,9.93643919 C5.85831349,9.93643919 4.67840679,8.75658593 4.67840679,7.30742299 C4.67840679,5.85751182 5.85826005,4.67840679 7.30742299,4.67840679 Z"></path></g></svg>
                        <span>{{ campus_location }}</span>
                    </li>
                </ul>
            </div>
            <div class="card__footer panel panel--white">
                <div class="button button--small  button--swipe button--white button--transparent">
                    <div class="button__background"></div>
                    <div class="button__icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="37.928" height="38.97" viewBox="0 0 37.928 38.97"><defs><clipPath id="clip-path"><rect id="Rectangle_45" data-name="Rectangle 45" width="38.97" height="37.928" stroke-width="4"></rect></clipPath></defs> <g id="arrow-right" transform="translate(0 38.97) rotate(-90)"><g id="Group_71" data-name="Group 71" transform="translate(0 0)" clip-path="url(#clip-path)"><path id="Line_25" data-name="Line 25" d="M9.609,33.113H0V0H9.609Z" transform="translate(14.68 0)"></path> <path id="Path_9" data-name="Path 9" d="M17.039,20.5,0,7.677,5.779,0,19.836,10.582,32.933.089l6.009,7.5L22.933,20.415Z" transform="translate(-0.035 18.804)"></path></g></g></svg>
                    </div>
                    <span>Read more</span>
                </div>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        event: Array,
        ext_url: Boolean,
        fallback_thumbnail: String,
        locations: Array
    },
    data() {
        return {
            start_date: null,
            end_date: null,
            online_event: false,
            campus: false,
            campus_location: ''
        }
    },
    computed: {
        event_url() {
            // Check if the toggle for using external URLs is set
            if(this.ext_url == true) {
                // If so then see if an external URL value is set
                if(this.event.url.length > 0) {
                    // If so use it
                    return this.event.url;
                } else {
                    // Otherwise use the Events Factory page URL
                    return 'https://www.kent.ac.uk/events/event/'+this.event.id+'/'+this.event.slug;
                }
            } else {
                // Use the Events Factory page URL
                return 'https://www.kent.ac.uk/events/event/'+this.event.id+'/'+this.event.slug;
            }
        }
    },
    methods: {
        event_location() {
            if(this.event.campus == 0 || this.event.location.includes('Online') || this.event.location.includes('Teams')) {
                this.online_event = true;
            }
            if(this.event.campus > 0) {
                this.campus = true;
                for(var i = 0; i < this.locations.length; i++) {
                    if(this.event.campus == this.locations[i].id) {
                        this.campus_location = this.locations[i].name.replace(' Campus','');
                    }
                }
            }
            return false;
        },
        event_date() {
            var start = this.event_month(this.event.start) + ' ' + this.event_day(this.event.start);
            var end = this.event_month(this.event.end) + ' ' + this.event_day(this.event.end);
            var string = start;
            if(start !== end) {
                string += ' - ' + end
            }
            return string;
        },
        event_day(date) {
            let converted_date = new Date(date.replace(" ", "T"));
            return converted_date.getDate();
        },
        event_month(date) {
            let converted_date = new Date(date.replace(" ", "T"));
            var month = converted_date.getMonth()+1;
            const month_names = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            return month_names[month];
        },
        event_time(date) {
            let converted_date = new Date(date.replace(" ", "T"));
            let time = converted_date.toISOString().replace(/^[^:]*([0-2]\d:[0-5]\d).*$/, "$1");
            return time;
        }
    },
    created() {
        this.event_location();
    }
}
</script>
